module.exports = __webpack_public_path__ + "img/storelDImg.c5f107b5.png";